type XAxisWithLabelsProps = {
  xMin?: number
  xMax?: number
  interval?: number
  ctx: CanvasRenderingContext2D
  canvasWidth: number
}

export function drawXAxisWithLabels({
  xMin = 0,
  xMax = 100,
  interval = 20,
  ctx,
  canvasWidth
}: XAxisWithLabelsProps): void {
  const paddingLeft = 3
  const paddingRight = 6

  const lastValue = xMax.toFixed()

  ctx.font = '10px Inter'
  ctx.fillStyle = 'rgba(82, 102, 122, 1)'
  ctx.textAlign = 'center'

  for (let x = xMin; x <= xMax; x += interval) {
    const xPos = mapXToCanvas(x, xMin, xMax, paddingLeft, canvasWidth - paddingRight)
    ctx.fillText(x.toString(), xPos, 15)
  }

  if (xMax % interval > interval / 2) {
    const xPos = mapXToCanvas(
      Number(lastValue),
      xMin,
      xMax,
      paddingLeft,
      canvasWidth - paddingRight
    )
    ctx.fillText(lastValue.toString(), xPos, 15)
  }
}

function mapXToCanvas(
  value: number,
  min: number,
  max: number,
  left: number,
  right: number
): number {
  const range = max - min
  if (range === 0) return left
  return ((value - min) / range) * (right - left) + left
}
